export var FolderType;
(function (FolderType) {
    FolderType[FolderType["Public"] = 0] = "Public";
    FolderType[FolderType["Private"] = 1] = "Private";
    FolderType[FolderType["Datatoken"] = 2] = "Datatoken";
})(FolderType || (FolderType = {}));
export const TEMP = "temp";
export const APP_VERSION = "0.2.0";
